import React, { useContext, useState } from "react";
import cx from "classnames";
import styles from "../scss/DapQuestion.module.scss";
import Icon from "../../common/components/Icon/Icon";
import Button from "../../common/components/Forms/Button/Button";
import { getOptionImages } from "../shared/digitalAdviceHelper";
import { AdviceControllerContext } from "../providers/DigitalAdviceProvider";
import {
    IDigitalSubQuestion,
    IQuestionOptionImage
} from "../interfaces/IDigitalAdviceData";
import DAQuestionFieldImage from "./DAQuestionFieldImage";
import { ISumbitParams } from "./DigitalAdviceQuestion";
import useWindowDimensions from "../../common/hooks/useWindowDimensions";
import { Form, Formik } from "formik";

interface ICheckboxListFieldProps {
    questionId?: number;
    list: IDigitalSubQuestion[];
    onSubmit: (answerList: ISumbitParams[]) => void;
    maxWidth?: string;
    isPlaceholderField?: boolean;
    addFrameImage?: (image: IQuestionOptionImage, isAdded: boolean) => void;
}

const CheckboxListField: React.FC<ICheckboxListFieldProps> = (props) => {
    const { list, onSubmit, maxWidth, isPlaceholderField } = props;

    const [checkList, setCheckList] = useState<number[]>([]);
    const [isSubmit, setIsSubmit] = useState(false);

    const { selectors } = useContext(AdviceControllerContext);
    const { isTabletPortrait } = useWindowDimensions();

    const handleImagesToSet = (option, isAdded = false): void => {
        props.addFrameImage(getOptionImages(option), isAdded);
    };

    const handleCheckList = (option): void => {
        const { id, deselectOthers } = option;
        setIsSubmit(false);
        if (!!deselectOthers) {
            const defaulOpt = (list?.length && list[0]) || {};
            setCheckList([id]);
            handleImagesToSet(defaulOpt);
            return;
        }
        if (!!checkList.find((i) => i === id)) {
            const newList = checkList.filter((i) => i !== id);
            if (!isPlaceholderField || (isPlaceholderField && !newList.length)) {
                handleImagesToSet(option);
            }
            setCheckList(newList);
        } else {
            const deselectOption = list.find((i) => i.deselectOthers);
            const newList = checkList.filter((i) => i !== deselectOption?.id || 0);
            handleImagesToSet(option, true);
            setCheckList([...newList, id]);
        }
    };

    const handleOnSubmit = (): void => {
        if (isSubmit || !checkList.length) {
            return;
        }
        setIsSubmit(true);
        const answerList = checkList.reduce((acc, id) => {
            const obj = {
                questionId: props.questionId ? props.questionId : id,
                textValue: props.questionId ? null : "true",
                questionOptionId: props.questionId ? id : null,
                sessionUserId: selectors.getSessionUserId()
            };
            acc = [...acc, obj];
            return acc;
        }, []);
        onSubmit(answerList);
    };

    return (
        <Formik initialValues={{}} onSubmit={handleOnSubmit}>
            {({ isSubmitting }) => (
                <Form className={styles["field-checkboxlist"]}>
                    <div
                        className={cx([
                            styles["field-radio-button"],
                            list.length >= 6 ? styles["with--two-columns"] : ""
                        ])}
                        style={
                            list.length >= 6 && !isTabletPortrait
                                ? { gridTemplateColumns: "1fr 1fr", maxWidth: "unset" }
                                : { maxWidth }
                        }>
                        {list.map((opt, idx) => (
                            <div className={styles["radio-button"]} key={idx}>
                                <input
                                    type="checkbox"
                                    id={`radiocontrol-${idx}`}
                                    name="radioControl"
                                    value={opt.id}
                                    checked={!!checkList.find((i) => i === opt.id)}
                                    onChange={() => {
                                        handleCheckList(opt);
                                    }}
                                    disabled={isSubmit}
                                />
                                <label
                                    className={styles["radion-button--label-container"]}
                                    htmlFor={`radiocontrol-${idx}`}>
                                    <div className={styles["img-container"]}>
                                        <DAQuestionFieldImage imgUrl={opt.imgUrl} />
                                    </div>
                                    <p className={styles["rb--label"]}>{opt.label}</p>
                                    <div className={styles["rb--checkicon-container"]}>
                                        <div className={styles["rb--checkicon"]}></div>
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div>

                    <div className={styles.buttonNext}>
                        <Button
                            className={cx("get-started")}
                            width="content"
                            component="button"
                            size="m"
                            type="submit"
                            isDisabled={!checkList.length || isSubmitting}
                            variant="calltoaction">
                            <span>Next</span>
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default CheckboxListField;
